// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../fonts/Urbanist-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Urbanist';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); }

.dmr-chart-container {
  min-height: 240px;
  min-width: 170px;
  width: 320px;
  background-color: #18244c; }

.dmr-chart-tooltip .tooltip-inner {
  background-color: unset !important; }

.DischargeMonitoring {
  color: #fff;
  background-color: #050e25;
  height: calc(100% - 80px);
  margin: 0px;
  padding: 0px;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 10px; }
  .DischargeMonitoring .expand-container {
    position: absolute;
    top: 45px !important;
    left: 75px;
    height: 93vh !important;
    width: 95%;
    z-index: 100; }
  .DischargeMonitoring .expand-container .table-container {
    max-height: 84vh !important;
    margin-left: 15px !important; }
  .DischargeMonitoring .fullscreen,
  .DischargeMonitoring .more-options {
    background-color: unset;
    border: unset; }
    .DischargeMonitoring .fullscreen img,
    .DischargeMonitoring .more-options img {
      filter: invert(1); }
  .DischargeMonitoring .fullscreen:hover {
    filter: invert(80%) sepia(51%) saturate(6275%) hue-rotate(196deg) brightness(102%) contrast(104%); }
  .DischargeMonitoring .more-options:hover {
    filter: invert(80%) sepia(51%) saturate(6275%) hue-rotate(196deg) brightness(102%) contrast(104%); }
  .DischargeMonitoring .attribution-container {
    margin-top: 4px;
    text-align: end; }
  .DischargeMonitoring .attribution-container-textRun {
    font-size: 14pt;
    color: white; }
  .DischargeMonitoring .attribution-container-textRun-source {
    font-size: 14pt;
    color: white; }
  .DischargeMonitoring .mapboxgl-popup-content {
    opacity: .95;
    border-radius: 4px;
    width: 370px !important;
    background-color: #18244c; }
  .DischargeMonitoring .mapboxgl-popup-close-button {
    display: none; }
  .DischargeMonitoring .mapboxgl-popup-anchor-top .mapboxgl-popup-tip {
    border-bottom-color: #18244c;
    opacity: .8; }
  .DischargeMonitoring .popup-container {
    padding-top: 7px;
    padding-bottom: 32px;
    padding-left: 10px;
    padding-right: 4px;
    font-size: 14px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    font-weight: 500;
    opacity: .95;
    text-align: center;
    height: 215px;
    width: 300px !important;
    line-height: 10px;
    font-family: "Urbanist";
    display: flex;
    flex-direction: column; }
  .DischargeMonitoring .popup-content {
    display: flex;
    flex-direction: row;
    justify-content: flex-start; }
  .DischargeMonitoring .popup-content-left {
    text-align: right;
    margin-right: 10px;
    min-width: 110px;
    max-width: 110px;
    line-height: 14px;
    white-space: pre-wrap; }
  .DischargeMonitoring .popup-content-right {
    text-align: left;
    min-width: 220px;
    max-width: 350px;
    line-height: 14px;
    font-size: 18px;
    padding-right: 4px; }
  .DischargeMonitoring .popup-content-highlight {
    color: #49b4cd; }
  .DischargeMonitoring .popup-content-right-double {
    height: 22px;
    line-height: 18px; }
  .DischargeMonitoring .popup-content-right-triple {
    height: 44px;
    line-height: 16px; }
  .DischargeMonitoring .report-options-button-container {
    width: 200px;
    display: inline-flex;
    flex-flow: row-reverse;
    background-color: #050e25; }
  .DischargeMonitoring .container {
    display: flex;
    padding: 0;
    height: 90vh;
    margin-top: 8px;
    max-width: inherit;
    width: 100%; }
    .DischargeMonitoring .container input,
    .DischargeMonitoring .container select {
      margin-bottom: 50px; }
    .DischargeMonitoring .container .main-col {
      max-width: -webkit-fill-available; }
    .DischargeMonitoring .container .map-title {
      width: auto;
      white-space: nowrap;
      position: absolute;
      left: 59px;
      top: 0px;
      font-size: 1.25rem;
      padding: 5px;
      z-index: 90; }
    .DischargeMonitoring .container .table-container {
      background-color: #0b1736;
      border-radius: 2px;
      box-shadow: 0px 0px 20px #000;
      display: flex;
      position: relative;
      margin-left: 1px;
      margin-top: 10px;
      max-height: 40vh;
      overflow-y: auto; }
    .DischargeMonitoring .container .reportTable {
      min-height: 10vh;
      color: white; }
    .DischargeMonitoring .container .map-best-container {
      background-color: #0b1736;
      border-radius: 2px;
      box-shadow: 0px 0px 20px #000;
      display: flex;
      position: relative;
      padding-left: 0px !important;
      height: 40vh;
      width: calc(100% - 280px);
      border-radius: 7px;
      padding: 0px !important; }
    .DischargeMonitoring .container .map-legend {
      width: 150px;
      position: absolute;
      border-radius: 5px;
      padding: 5px;
      right: 40px;
      bottom: 10px;
      padding-bottom: 10px;
      background-color: #18244c;
      z-index: 90;
      height: 170px; }
    .DischargeMonitoring .container .map-legend p {
      margin-left: 5px;
      margin-bottom: 7px;
      height: 45px; }
    .DischargeMonitoring .container .map-legend span {
      width: 100px;
      margin-left: 5px; }
    .DischargeMonitoring .container .map-legend-div {
      display: flex;
      flex-flow: column;
      height: 100%;
      flex-wrap: wrap; }
    .DischargeMonitoring .container .map-legend-dot-div {
      width: 70px;
      white-space: nowrap; }
    .DischargeMonitoring .container .map-legend-dot {
      background-color: #4b5ea6;
      height: 14px;
      width: 14px;
      margin-left: 5px;
      margin-right: 5px;
      border-radius: 50%;
      display: inline-flex; }
    .DischargeMonitoring .container .attribution-textbox {
      font-size: .6rem;
      position: absolute;
      right: 1px;
      bottom: 0px;
      width: auto; }
    .DischargeMonitoring .container .expand-container-summary {
      position: absolute;
      top: 70px;
      left: 90px;
      height: 90vh !important;
      width: 96% !important;
      z-index: 100;
      padding-top: 45px !important;
      overflow: scroll !important;
      flex-flow: wrap; }
    .DischargeMonitoring .container .expand-summary-button {
      display: unset;
      position: absolute;
      top: 1px;
      left: 0px;
      z-index: 1001; }
    .DischargeMonitoring .container .expand-container .table-container {
      max-height: 84vh !important;
      margin-left: 15px !important;
      min-height: 84vh !important; }
    .DischargeMonitoring .container .summary-container {
      background-color: #0b1736;
      border-radius: 2px;
      box-shadow: 0px 0px 20px #000;
      display: flex;
      margin-top: 0px;
      margin-left: 5px;
      margin-right: 20px;
      padding-top: 0px;
      height: 40vh;
      width: 250px;
      overflow-x: hidden;
      overflow-y: scroll;
      flex-direction: column;
      border-radius: 7px; }
    .DischargeMonitoring .container .summary-title {
      margin-left: 5px;
      flex-direction: row;
      width: 200px; }
    .DischargeMonitoring .container .summary-title Button {
      margin-left: 15px;
      background-color: #fff;
      border: unset; }
    .DischargeMonitoring .container .summary-title img {
      vertical-align: unset !important; }
    .DischargeMonitoring .container .summary-title Button:hover {
      background-color: #257ee0; }
    .DischargeMonitoring .container .summary-button {
      width: 44px;
      display: inline-flex;
      align-self: flex-end;
      background-color: white; }
    .DischargeMonitoring .container .card {
      padding-left: 2px;
      width: 210px;
      line-height: 18px;
      margin-bottom: 10px;
      max-width: 210px;
      border-radius: 2px; }
    .DischargeMonitoring .container .card-header {
      height: 37px; }
    .DischargeMonitoring .container .card-title {
      line-height: 5px;
      font-size: 1.2rem; }
    .DischargeMonitoring .container .summary-container-span {
      font-size: 1.2rem; }
    .DischargeMonitoring .container .te-primary {
      background-color: #050e25; }
    .DischargeMonitoring .container .te-secondary {
      background-color: #4fc32c; }
    .DischargeMonitoring .container .te-blue {
      background-color: #0b61bf; }
    .DischargeMonitoring .container .summary-top {
      width: 100px; }
    .DischargeMonitoring .container .summary-field-name {
      font-size: 12px;
      color: gray;
      padding-bottom: 5px; }
    .DischargeMonitoring .container .summary-field-double {
      height: auto;
      line-height: 18px;
      min-height: 37px; }
    .DischargeMonitoring .container .chart-line-container {
      height: 100%;
      width: 100%;
      width: -webkit-fill-available;
      width: -moz-available;
      width: stretch; }
    .DischargeMonitoring .container .report-options {
      margin-top: 30px;
      text-align: right;
      margin-right: 8px; }
      .DischargeMonitoring .container .report-options button {
        background-color: #fff;
        border: unset;
        margin-left: 10px; }
      .DischargeMonitoring .container .report-options button:hover {
        background-color: #257ee0; }
`, "",{"version":3,"sources":["webpack://./src/theme/_variables.scss","webpack://./src/features/reports/DischargeMonitoring/styles.scss"],"names":[],"mappings":"AAqBA;EACE,uBAAuB;EACvB,4CAAmD,EAAA;;ACdrD;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,yBAAyB,EAAA;;AAG3B;EACE,kCAAkC,EAAA;;AAGpC;EACE,WDrBqB;ECsBrB,yBDTsC;ECUtC,yBAAyB;EAEzB,WAAW;EACX,YAAY;EAEZ,kBA1BoB;EA2BpB,mBA3BoB;EA4BpB,iBA3BmB,EAAA;EAiBrB;IAaI,kBAAkB;IAClB,oBAAoB;IACpB,UAAU;IACV,uBAAuB;IACvB,UAAU;IACV,YAAY,EAAA;EAlBhB;IAsBI,2BAA2B;IAC3B,4BAA4B,EAAA;EAvBhC;;IA4BI,uBAAuB;IACvB,aAAa,EAAA;IA7BjB;;MAgCM,iBAAiB,EAAA;EAhCvB;IAqCI,iGAAiG,EAAA;EArCrG;IAyCI,iGAAiG,EAAA;EAzCrG;IA6CI,eAAe;IACf,eAAe,EAAA;EA9CnB;IAkDI,eAAe;IACf,YAAY,EAAA;EAnDhB;IAuDI,eAAe;IACf,YAAY,EAAA;EAxDhB;IA4DI,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,yBAAyB,EAAA;EA/D7B;IAmEI,aAAa,EAAA;EAnEjB;IAuEI,4BAA4B;IAC5B,WAAW,EAAA;EAxEf;IA4EI,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,iBAAiB;IACjB,uBAAuB;IACvB,aAAa;IACb,sBAAsB,EAAA;EA5F1B;IAgGI,aAAa;IACb,mBAAmB;IACnB,2BAA2B,EAAA;EAlG/B;IAuGI,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB,EAAA;EA5GzB;IAgHI,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,kBAAkB,EAAA;EArHtB;IAyHI,cAAc,EAAA;EAzHlB;IA6HI,YAAY;IACZ,iBAAiB,EAAA;EA9HrB;IAkII,YAAY;IACZ,iBAAiB,EAAA;EAnIrB;IAuII,YAAY;IACZ,oBAAoB;IACpB,sBAAsB;IACtB,yBAAyB,EAAA;EA1I7B;IA8II,aAAa;IACb,UAAU;IACV,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,WAAW,EAAA;IAnJf;;MAuJM,mBAAmB,EAAA;IAvJzB;MA2JM,iCAAiC,EAAA;IA3JvC;MA+JQ,WAAW;MACX,mBAAmB;MACnB,kBAAkB;MAClB,UAAU;MACV,QAAQ;MACR,kBAAkB;MAClB,YAAY;MACZ,WAAW,EAAA;IAtKnB;MA0KQ,yBD3LwB;MC4LxB,kBAAkB;MAClB,6BAA6B;MAC7B,aAAa;MACb,kBAAkB;MAClB,gBAAgB;MAChB,gBAAgB;MAChB,gBAAgB;MAChB,gBAAgB,EAAA;IAlLxB;MAsLQ,gBAAgB;MAChB,YAAY,EAAA;IAvLpB;MA2LM,yBD5M0B;MC6M1B,kBAAkB;MAClB,6BAA6B;MAC7B,aAAa;MACb,kBAAkB;MAClB,4BAA4B;MAC5B,YAAY;MACZ,yBAAyB;MACzB,kBAAkB;MAClB,uBAAuB,EAAA;IApM7B;MAwMM,YAAY;MACZ,kBAAkB;MAClB,kBAAkB;MAClB,YAAY;MACZ,WAAW;MACX,YAAY;MACZ,oBAAoB;MACpB,yBAAyB;MACzB,WAAW;MACX,aAAa,EAAA;IAjNnB;MAqNM,gBAAgB;MAChB,kBAAkB;MAClB,YAAY,EAAA;IAvNlB;MA2NM,YAAY;MACZ,gBAAgB,EAAA;IA5NtB;MAgOM,aAAa;MACb,iBAAiB;MACjB,YAAY;MACZ,eAAe,EAAA;IAnOrB;MAuOM,WAAU;MACV,mBAAmB,EAAA;IAxOzB;MA4OM,yBAAyB;MACzB,YAAY;MACZ,WAAW;MACX,gBAAgB;MAChB,iBAAiB;MACjB,kBAAkB;MAClB,oBAAoB,EAAA;IAlP1B;MAsPM,gBAAgB;MAChB,kBAAkB;MAClB,UAAU;MACV,WAAW;MACX,WAAW,EAAA;IA1PjB;MA8PM,kBAAkB;MAClB,SAAS;MACT,UAAU;MACV,uBAAuB;MACvB,qBAAqB;MACrB,YAAY;MACZ,4BAA4B;MAC5B,2BAA2B;MAC3B,eAAe,EAAA;IAtQrB;MA0QM,cAAc;MACd,kBAAkB;MAClB,QAAQ;MACR,SAAS;MACT,aAAa,EAAA;IA9QnB;MAkRM,2BAA2B;MAC3B,4BAA4B;MAC5B,2BAA2B,EAAA;IApRjC;MAwRM,yBDzS0B;MC0S1B,kBAAkB;MAClB,6BAA6B;MAC7B,aAAa;MACb,eAAe;MACf,gBAAgB;MAChB,kBAAkB;MAClB,gBAAgB;MAChB,YAAW;MACX,YAAY;MACZ,kBAAkB;MAClB,kBAAkB;MAClB,sBAAsB;MACtB,kBAAkB,EAAA;IArSxB;MAySM,gBAAgB;MAChB,mBAAmB;MACnB,YAAY,EAAA;IA3SlB;MA+SM,iBAAiB;MACjB,sBAAsB;MACtB,aAAa,EAAA;IAjTnB;MAqTM,gCAAgC,EAAA;IArTtC;MAyTM,yBAAyB,EAAA;IAzT/B;MA6TM,WAAW;MACX,oBAAoB;MACpB,oBAAoB;MACpB,uBAAuB,EAAA;IAhU7B;MAoUM,iBAAiB;MACjB,YAAY;MACZ,iBAAiB;MACjB,mBAAmB;MACnB,gBAAgB;MAChB,kBAAkB,EAAA;IAzUxB;MA6UM,YAAY,EAAA;IA7UlB;MAiVM,gBAAgB;MAChB,iBAAiB,EAAA;IAlVvB;MAsVM,iBAAiB,EAAA;IAtVvB;MA0VM,yBAAyB,EAAA;IA1V/B;MA8VM,yBAAyB,EAAA;IA9V/B;MAkWM,yBAAyB,EAAA;IAlW/B;MAsWM,YAAY,EAAA;IAtWlB;MA0WM,eAAe;MACf,WAAW;MACX,mBAAmB,EAAA;IA5WzB;MAgXM,YAAY;MACZ,iBAAiB;MACjB,gBAAgB,EAAA;IAlXtB;MAwXQ,YAAY;MACZ,WAAW;MAEX,6BAA6B;MAC7B,qBAAc;MAAd,cAAc,EAAA;IA5XtB;MAgYM,gBAAgB;MAChB,iBAAiB;MACjB,iBAAiB,EAAA;MAlYvB;QAqYQ,sBAAsB;QACtB,aAAa;QACb,iBAAiB,EAAA;MAvYzB;QA2YQ,yBAAyB,EAAA","sourcesContent":["$primaryFontColor: #fff;\n$secundaryFontColor: #4fc2d9;\n$thirdFontColor: #0b1736;\n$topMenuBackgroundColor: #0b1736;\n$sideBackgroundColor: #002044;\n$sideSubMenuBackgroundColor: #0b1736;\n$fontFamily: 'Urbanist';\n$leftMenuWidth: 5rem;\n$rightMenuWidth: 400px;\n$navBrandImageSize: 150px;\n$darkAndLightModeBackgroundColor: #12234f;\n$dropdownFiltersBackgroundColor: #060e21;\n$inputFocusBackgroundColor: #060e21;\n$containerScreenBackgroundColor: #050e25;\n$tableBackgroundColor: #0b1736;\n$secondarySubtitleColor: #838487;\n\n//FORMS\n$inputBackgroundColor: #021d3e;\n$btnPrimary: #257ee0;\n\n@font-face {\n  font-family: 'Urbanist';\n  src: url('../fonts/Urbanist-VariableFont_wght.ttf');\n}\n","@import \"../../../theme/_variables.scss\";\n\n$paddingLeftSize: 10px;\n$paddingTopSize: 10px;\n$tableDividerLineColor: #222224;\n$tableDividerLineBorderSize: 0.5px;\n$tableFontSize: 1.2vw;\n$positionTop: 140px;\n\n.dmr-chart-container {\n  min-height: 240px;\n  min-width: 170px;\n  width: 320px;\n  background-color: #18244c;\n}\n\n.dmr-chart-tooltip .tooltip-inner{\n  background-color: unset !important;\n}\n\n.DischargeMonitoring {\n  color: $primaryFontColor;\n  background-color: $containerScreenBackgroundColor;\n  height: calc(100% - 80px);\n  \n  margin: 0px;\n  padding: 0px;\n \n  padding-left: $paddingLeftSize;\n  padding-right: $paddingLeftSize;\n  padding-top: $paddingTopSize;\n\n  .expand-container {\n    position: absolute;\n    top: 45px !important;\n    left: 75px;\n    height: 93vh !important;\n    width: 95%;\n    z-index: 100;\n  }\n\n  .expand-container .table-container{\n    max-height: 84vh !important;\n    margin-left: 15px !important;\n  }\n\n  .fullscreen,\n  .more-options {\n    background-color: unset;\n    border: unset;\n\n    img {\n      filter: invert(1);\n    }\n  }\n\n  .fullscreen:hover {\n    filter: invert(80%) sepia(51%) saturate(6275%) hue-rotate(196deg) brightness(102%) contrast(104%);\n  }\n\n  .more-options:hover {\n    filter: invert(80%) sepia(51%) saturate(6275%) hue-rotate(196deg) brightness(102%) contrast(104%);\n  }\n\n  .attribution-container {\n    margin-top: 4px;\n    text-align: end;\n  }\n\n  .attribution-container-textRun{\n    font-size: 14pt; \n    color: white;\n  }\n\n  .attribution-container-textRun-source {\n    font-size: 14pt; \n    color: white;\n  }\n\n  .mapboxgl-popup-content {\n    opacity: .95;\n    border-radius: 4px;\n    width: 370px !important;\n    background-color: #18244c;\n  }\n\n  .mapboxgl-popup-close-button{\n    display: none;\n  }\n\n  .mapboxgl-popup-anchor-top .mapboxgl-popup-tip {\n    border-bottom-color: #18244c;\n    opacity: .8;\n  }    \n\n  .popup-container {\n    padding-top: 7px;\n    padding-bottom: 32px;\n    padding-left: 10px;\n    padding-right: 4px;\n    font-size: 14px;\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    font-weight: 500;\n    opacity: .95;\n    text-align: center;\n    height: 215px;\n    width: 300px !important;\n    line-height: 10px;\n    font-family: \"Urbanist\";\n    display: flex;\n    flex-direction: column;\n  }\n\n  .popup-content {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n  }\n\n\n  .popup-content-left {\n    text-align: right;\n    margin-right: 10px;\n    min-width: 110px;\n    max-width: 110px;\n    line-height: 14px;\n    white-space: pre-wrap;\n  }\n\n  .popup-content-right {\n    text-align: left;\n    min-width: 220px;\n    max-width: 350px;\n    line-height: 14px;\n    font-size: 18px;\n    padding-right: 4px;\n  }\n\n  .popup-content-highlight {\n    color: #49b4cd;\n  }\n\n  .popup-content-right-double{\n    height: 22px;\n    line-height: 18px;\n  }\n\n  .popup-content-right-triple{\n    height: 44px;\n    line-height: 16px;\n  }\n\n  .report-options-button-container {\n    width: 200px;\n    display: inline-flex;\n    flex-flow: row-reverse;\n    background-color: #050e25;\n  }\n\n  .container {\n    display: flex;\n    padding: 0;\n    height: 90vh;\n    margin-top: 8px;\n    max-width: inherit;\n    width: 100%;\n\n    input,\n    select {\n      margin-bottom: 50px;\n    }\n\n    .main-col {\n      max-width: -webkit-fill-available;\n    }\n\n    .map-title {\n        width: auto;\n        white-space: nowrap;\n        position: absolute;\n        left: 59px; \n        top: 0px;\n        font-size: 1.25rem;\n        padding: 5px;\n        z-index: 90;\n     }\n\n     .table-container {\n        background-color: $topMenuBackgroundColor;\n        border-radius: 2px;\n        box-shadow: 0px 0px 20px #000;\n        display: flex;\n        position: relative;\n        margin-left: 1px;\n        margin-top: 10px;\n        max-height: 40vh;\n        overflow-y: auto;\n      }\n\n      .reportTable {\n        min-height: 10vh;\n        color: white;\n      }\n\n    .map-best-container {\n      background-color: $topMenuBackgroundColor;\n      border-radius: 2px;\n      box-shadow: 0px 0px 20px #000;\n      display: flex;\n      position: relative;\n      padding-left: 0px !important;\n      height: 40vh;\n      width: calc(100% - 280px);\n      border-radius: 7px;\n      padding: 0px !important;\n    }\n\n    .map-legend {\n      width: 150px;\n      position: absolute;\n      border-radius: 5px;\n      padding: 5px;\n      right: 40px; \n      bottom: 10px;\n      padding-bottom: 10px;\n      background-color: #18244c;\n      z-index: 90;\n      height: 170px;\n    }\n\n    .map-legend p{\n      margin-left: 5px;\n      margin-bottom: 7px;\n      height: 45px;\n    }\n  \n    .map-legend span{\n      width: 100px;\n      margin-left: 5px;\n    }\n\n    .map-legend-div {\n      display: flex;\n      flex-flow: column;\n      height: 100%;\n      flex-wrap: wrap;\n    }\n\n    .map-legend-dot-div{\n      width:70px;\n      white-space: nowrap;\n    }\n\n    .map-legend-dot {\n      background-color: #4b5ea6;\n      height: 14px;\n      width: 14px;\n      margin-left: 5px;\n      margin-right: 5px;\n      border-radius: 50%;\n      display: inline-flex;\n    }\n\n    .attribution-textbox {\n      font-size: .6rem;\n      position: absolute;\n      right: 1px;\n      bottom: 0px;\n      width: auto;\n    }\n\n    .expand-container-summary {\n      position: absolute;\n      top: 70px;\n      left: 90px;\n      height: 90vh !important;\n      width: 96% !important;\n      z-index: 100;\n      padding-top: 45px !important;\n      overflow: scroll !important;\n      flex-flow: wrap;\n    }\n\n    .expand-summary-button {\n      display: unset;\n      position: absolute;\n      top: 1px;\n      left: 0px;\n      z-index: 1001;\n    }\n\n    .expand-container .table-container{\n      max-height: 84vh !important;\n      margin-left: 15px !important;\n      min-height: 84vh !important;\n    }\n\n    .summary-container {\n      background-color: $topMenuBackgroundColor;\n      border-radius: 2px;\n      box-shadow: 0px 0px 20px #000;\n      display: flex;\n      margin-top: 0px;\n      margin-left: 5px;\n      margin-right: 20px;\n      padding-top: 0px;\n      height:40vh;\n      width: 250px;\n      overflow-x: hidden;\n      overflow-y: scroll;\n      flex-direction: column;\n      border-radius: 7px;\n    }\n\n    .summary-title {\n      margin-left: 5px;\n      flex-direction: row;\n      width: 200px;\n    }\n\n    .summary-title Button{\n      margin-left: 15px;\n      background-color: #fff;\n      border: unset;\n    }\n\n    .summary-title img{\n      vertical-align: unset !important;\n    }\n \n    .summary-title Button:hover {\n      background-color: #257ee0;\n    }\n\n    .summary-button {\n      width: 44px; \n      display: inline-flex;\n      align-self: flex-end;\n      background-color: white;\n    }\n\n    .card {\n      padding-left: 2px;\n      width: 210px;\n      line-height: 18px;\n      margin-bottom: 10px;\n      max-width: 210px;\n      border-radius: 2px;\n    }\n\n    .card-header {\n      height: 37px;\n    }\n\n    .card-title {\n      line-height: 5px;\n      font-size: 1.2rem;\n    }\n\n    .summary-container-span {\n      font-size: 1.2rem;\n    }\n\n    .te-primary {\n      background-color: #050e25;\n    }\n\n    .te-secondary {\n      background-color: #4fc32c;\n    }\n\n    .te-blue {\n      background-color: #0b61bf;\n    }\n\n    .summary-top {\n      width: 100px;\n    }\n\n    .summary-field-name {\n      font-size: 12px;\n      color: gray;\n      padding-bottom: 5px;\n    }\n\n    .summary-field-double {\n      height: auto;\n      line-height: 18px;\n      min-height: 37px;\n    }\n\n\n\n    .chart-line-container {\n        height: 100%;\n        width: 100%;\n        width: -moz-available; \n        width: -webkit-fill-available;\n        width: stretch;  \n    }\n\n    .report-options {\n      margin-top: 30px;\n      text-align: right;\n      margin-right: 8px;\n\n      button {\n        background-color: #fff;\n        border: unset;\n        margin-left: 10px;\n      }\n\n      button:hover {\n        background-color: #257ee0;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
